import { Injectable } from '@angular/core';
import { OwlDateTimeIntl } from '@danielmoncada/angular-datetime-picker';
    
@Injectable()
export class DefaultDateTimeIntl extends OwlDateTimeIntl {
  public cancelBtnLabel = 'Cancelar';
  public setBtnLabel = 'Aplicar';
}